import React, { useState } from "react";
// import Header from "../Header/HeaderComponent";
import { Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-step1.css";
import ImageInput from "../../components/form/ImageInput/ImageInput";
import SelectInput from "../../components/form/SelectInput";
import TextInput from "../../components/form/TextInput";
import LoadingPage from "../../components/LoadingPage/LoadingPage";
import { DOCUMENT_NAMES } from "../../constants/documents";
import { useJobOptions } from "../../constants/fill-form";
import { useFetchMouCompanies } from "../../features/loans/hooks/useFetchMouCompanies";
import { useFileUpload } from "../../hooks/useFileUpload";
import { useUser } from "../../hooks/useUser";
import { useLoanStore } from "../../stores/useLoanStore";
import { syncFileNameWithBankName } from "../../utils/file";
import FormattedNumberInput from "../../components/form/FormattedNumberInput";
import {
  getFirstFillFormInitialValues,
  getFirstFillFormSchema,
} from "../../utils/fill-form";
import Header from "../Header/stepHeader";
import { useTranslation } from "react-i18next";
import FooterButton from "../../components/ui/Button/FooterButton";

const FillFormStep = () => {
  const {
    BANK_NAME_OPTIONS,
    HIRE_TYPE_OPTIONS,
    JOB_LEVEL_LIST,
    JOB_NAME_LIST,
    JOB_TYPES,
  } = useJobOptions();
  const { data: mouCompanies, isFetching: isFetchingMouCompanies } =
    useFetchMouCompanies();
  const { t } = useTranslation("form1");
  const { userData } = useUser();

  const isForeigner = userData?.is_foreigner;

  const { is_mou: isMou } = useLoanStore((state) => state.incomeFormProfile);

  const {
    fileInfo: receiptEvidenceFileInfo,
    propagateFileChange: propagateReceiptEvidenceFileChange,
    errorMessage: receiptEvidenceErrorMessage,
    setErrorMessage: setReceiptEvidenceErrorMessage,
  } = useFileUpload(DOCUMENT_NAMES.SALARY_RECEIPT);

  const [firstStatementBank, setFirstStatementBank] = useState(null);

  const {
    fileInfo: firstStatementFileInfo,
    propagateFileChange: propagateFirstStatementFileChange,
    onSetFileInfo: onSetFirstStatementFileInfo,
  } = useFileUpload(`${DOCUMENT_NAMES.STATEMENT}${firstStatementBank}`);

  const [secondStatementBank, setSecondStatementBank] = useState(null);

  const {
    fileInfo: secondStatementFileInfo,
    propagateFileChange: propagateSecondStatementFileChange,
    onSetFileInfo: onSetSecondStatementFileInfo,
  } = useFileUpload(`${DOCUMENT_NAMES.STATEMENT}${secondStatementBank}`);

  const [thirdStatementBank, setThirdStatementBank] = useState(null);

  const {
    fileInfo: thirdStatementFileInfo,
    propagateFileChange: propagateThirdStatementFileChange,
    onSetFileInfo: onSetThirdStatementFileInfo,
  } = useFileUpload(`${DOCUMENT_NAMES.STATEMENT}${thirdStatementBank}`);

  const {
    fileInfo: ncbFileInfo,
    propagateFileChange: propagateNcbFileChange,
    errorMessage: ncbErrorMessage,
    setErrorMessage: setNcbErrorMessage,
  } = useFileUpload(DOCUMENT_NAMES.NCB);

  const {
    propagateFileChange: propagateMouFileChange,
    fileInfo: mouFileInfo,
    errorMessage: mouErrorMessage,
    setErrorMessage: setMouErrorMessage,
  } = useFileUpload(DOCUMENT_NAMES.MOU);

  const incomeFormProfile = useLoanStore((state) => state.incomeFormProfile);

  const {
    fileInfo: otherDocumentFileInfo,
    propagateFileChange: propagateOtherDocumentFileChange,
  } = useFileUpload(DOCUMENT_NAMES.OTHER);

  const setFirstFillFormData = useLoanStore(
    (state) => state.setFirstFillFormData
  );

  const navigate = useNavigate();

  console.log(mouErrorMessage, ncbErrorMessage);

  const handleSubmitForm = (values) => {
    setMouErrorMessage("");
    setNcbErrorMessage("");
    setReceiptEvidenceErrorMessage("");
    if (!mouFileInfo && isMou) {
      setMouErrorMessage(t("image1Required"));
      return;
    }
    if (!isMou && !isForeigner) {
      let isError = false;
      if (!receiptEvidenceFileInfo) {
        setReceiptEvidenceErrorMessage(t("image1Required"));
        isError = true;
      }
      if (!ncbFileInfo) {
        setNcbErrorMessage(t("imageForeign1Required"));
        isError = true;
      }
      if (isError) return;
    }

    setFirstFillFormData({
      ...values,
      attachment: [
        {
          name: DOCUMENT_NAMES.SALARY_RECEIPT,
          file: receiptEvidenceFileInfo?.file,
        },
        {
          name: `${DOCUMENT_NAMES.STATEMENT}${firstStatementBank}`,
          file: firstStatementFileInfo?.file,
        },
        {
          name: `${DOCUMENT_NAMES.STATEMENT}${secondStatementBank}`,
          file: secondStatementFileInfo?.file,
        },
        {
          name: `${DOCUMENT_NAMES.STATEMENT}${thirdStatementBank}`,
          file: thirdStatementFileInfo?.file,
        },
        {
          name: DOCUMENT_NAMES.NCB ?? `เอกสาร "NCB" (National Credit Bureau )`,
          file: ncbFileInfo?.file,
        },
        {
          name: DOCUMENT_NAMES.OTHER,
          file: otherDocumentFileInfo?.file,
        },
        {
          name: DOCUMENT_NAMES.MOU,
          file: mouFileInfo?.file,
        },
      ],
    });
    navigate("/loan-process/form-step2");
  };

  function getUpdatedFormInitialValues() {
    return {
      ...getFirstFillFormInitialValues(),
      ...incomeFormProfile,
    };
  }

  if (isFetchingMouCompanies) return <LoadingPage message={t("loading")} />;

  return (
    <div id="pageFillForm">
      <Header
        title={t("header")}
        showIcon={false}
        onBack={() => navigate(-1)}
        step={3}
      />
      <div className="wrapContent">
        <div id="pFillForm">
          <div className="bFillForm">
            <div className="bContent">
              <div
                className="bSecondContent"
                style={{ overflow: "visible", height: "auto" }}
              >
                <div className="bTitle">
                  <h2>{t("title")}</h2>
                </div>
                <Formik
                  initialValues={getUpdatedFormInitialValues()}
                  validationSchema={getFirstFillFormSchema(isMou, isForeigner)}
                  onSubmit={handleSubmitForm}
                >
                  {({ handleSubmit, setFieldValue, errors, values }) => {
                    console.log(errors);

                    return (
                      <Form className="bForm" onSubmit={handleSubmit}>
                        {!isForeigner && !isMou && (
                          <div className="bInput">
                            <label
                              className="tText"
                              style={{ marginBottom: "12px" }}
                            >
                              {t("selectJobType")}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div role="group" className="bRadioGroup">
                              {JOB_TYPES.map((option) => (
                                <label
                                  style={{ cursor: "pointer" }}
                                  key={option.value}
                                  className={`bRadio ${
                                    values.job_type === option.value
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <Field
                                    type="radio"
                                    name="job_type"
                                    value={option.value}
                                    checked={values.job_type === option.value}
                                    onChange={() =>
                                      setFieldValue("job_type", option.value)
                                    }
                                  />
                                  {option.label}
                                </label>
                              ))}
                            </div>
                            {errors.job_type && (
                              <div style={{ color: "red" }}>
                                {errors.job_type}
                              </div>
                            )}
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <SelectInput
                            name="hire_type"
                            label={t("type")}
                            options={HIRE_TYPE_OPTIONS}
                            errorMessage={errors.hire_type}
                            placeholder={t("selectType")}
                            required
                          />
                          <SelectInput
                            name="job_name"
                            label={t("job")}
                            options={JOB_NAME_LIST}
                            placeholder={t("selectJob")}
                            errorMessage={errors.job_name}
                            required
                          />
                          {values.job_name === t("other") && (
                            <div className="bInput">
                              <TextInput
                                name="other_job_name"
                                label={t("specifyJob")}
                                placeholder={t("inputJob")}
                                errorMessage={errors.other_job_name}
                                required
                              />
                            </div>
                          )}
                          <SelectInput
                            name="jobLevel"
                            label={t("jobLevel")}
                            options={JOB_LEVEL_LIST}
                            errorMessage={errors.jobLevel}
                            placeholder={t("selectJobLevel")}
                            required
                          />
                          {isMou ? (
                            <SelectInput
                              name="current_company"
                              label={t("comapny")}
                              placeholder={t("selectCompany")}
                              options={mouCompanies?.map((company) => ({
                                value: company.id,
                                label: company.name,
                              }))}
                              errorMessage={errors.current_company}
                            />
                          ) : (
                            <TextInput
                              name="current_company"
                              label={t("comapny")}
                              placeholder={t("inputCompany")}
                              errorMessage={errors.current_company}
                              required
                            />
                          )}
                          <FormattedNumberInput
                            name="job_experience_in_year"
                            label={t("jobAge")}
                            placeholder={t("inputJobAge")}
                            errorMessage={errors.job_experience_in_year}
                            required
                            value={values.job_experience_in_year}
                            onChange={(value) => {
                              setFieldValue("job_experience_in_year", value);
                            }}
                          />

                          {/* รายได้ section */}
                          <div className="fIncome">
                            <div className="tTitle">
                              <h3>{t("revenue")}</h3>
                            </div>
                            <FormattedNumberInput
                              name="monthly_income"
                              label={t("monthlyRevenue")}
                              placeholder={t("inputMonthlyRevenue")}
                              errorMessage={errors.monthly_income}
                              required
                              value={values.monthly_income}
                              onChange={(value) => {
                                setFieldValue("monthly_income", value);
                              }}
                            />
                            <FormattedNumberInput
                              name="out_time_income"
                              label={t("ot")}
                              placeholder={t("inputOt")}
                              errorMessage={errors.out_time_income}
                              value={values.out_time_income}
                              onChange={(value) => {
                                setFieldValue("out_time_income", value);
                              }}
                            />
                            <FormattedNumberInput
                              name="other_income"
                              label={t("otherRevenue")}
                              placeholder={t("inputOtherRevenue")}
                              errorMessage={errors.other_income}
                              value={values.other_income}
                              onChange={(value) => {
                                setFieldValue("other_income", value);
                              }}
                            />
                          </div>
                          {/* รายจ่าย Section */}
                          <div className="fIncome">
                            <div className="tTitle">
                              <h3>{t("expenses")}</h3>
                            </div>
                            <FormattedNumberInput
                              name="debt_amount"
                              label={t("allLoan")}
                              placeholder={t("inputLoan")}
                              errorMessage={errors.debt_amount}
                              required
                              value={values.debt_amount}
                              onChange={(value) => {
                                setFieldValue("debt_amount", value);
                              }}
                            />
                            <FormattedNumberInput
                              name="monthly_debt"
                              label={t("monthlyExpenses")}
                              placeholder={t("inputExpenses")}
                              errorMessage={errors.monthly_debt}
                              required
                              value={values.monthly_debt}
                              onChange={(value) => {
                                setFieldValue("monthly_debt", value);
                              }}
                            />
                            <FormattedNumberInput
                              name="monthly_outcome"
                              label={t("monthlyInstallment")}
                              placeholder={t("inputInstallment")}
                              errorMessage={errors.monthly_outcome}
                              required
                              value={values.monthly_outcome}
                              onChange={(value) => {
                                setFieldValue("monthly_outcome", value);
                              }}
                            />
                            <FormattedNumberInput
                              name="total_debt"
                              label={t("overallLoan")}
                              placeholder={t("inputOverallLoan")}
                              errorMessage={errors.total_debt}
                              required
                              value={values.total_debt}
                              onChange={(value) => {
                                setFieldValue("total_debt", value);
                              }}
                            />
                          </div>
                          {isMou ? (
                            <ImageInput
                              label={t("image1")}
                              description={t("image1Desc")}
                              {...propagateMouFileChange()}
                              exampleImageUrl="/assets/img/ci/img/loan/example-mou.png"
                              placeholder={t("image1Place")}
                              required
                              errorMessage={mouErrorMessage}
                            />
                          ) : (
                            <>
                              <ImageInput
                                label={t("image2")}
                                description={t("image2Desc")}
                                {...propagateReceiptEvidenceFileChange()}
                                fileInfo={receiptEvidenceFileInfo}
                                required
                                errorMessage={receiptEvidenceErrorMessage}
                              />
                              <div className="bUpload">
                                <label className="label">
                                  {t("uploadBank")}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <SelectInput
                                  isFormik={false}
                                  label={t("selectBank")}
                                  placeholder={t("selectBank")}
                                  options={BANK_NAME_OPTIONS}
                                  value={firstStatementBank}
                                  required
                                  onChange={async (e) => {
                                    const bankName = e.target.value;

                                    setFirstStatementBank(bankName);

                                    await syncFileNameWithBankName(
                                      bankName,
                                      firstStatementFileInfo,
                                      onSetFirstStatementFileInfo
                                    );
                                  }}
                                  style={{ marginBottom: "12px" }}
                                />
                                <ImageInput
                                  // label="อัพโหลดรายการเดินบัญชีย้อนหลังไม่น้อยกว่า 6 เดือน (โหลดจากแอพธนาคาร)"
                                  placeholder={t("image3")}
                                  {...propagateFirstStatementFileChange()}
                                  fileInfo={firstStatementFileInfo}
                                  accept="application/pdf"
                                />
                              </div>
                              <div className="bUpload">
                                <label className="label">
                                  {t("uploadBank")}
                                </label>
                                <SelectInput
                                  isFormik={false}
                                  label={t("selectBank")}
                                  placeholder={t("selectBank")}
                                  options={BANK_NAME_OPTIONS}
                                  value={secondStatementBank}
                                  onChange={async (e) => {
                                    const bankName = e.target.value;

                                    setSecondStatementBank(bankName);

                                    await syncFileNameWithBankName(
                                      bankName,
                                      secondStatementFileInfo,
                                      onSetSecondStatementFileInfo
                                    );
                                  }}
                                  style={{ marginBottom: "12px" }}
                                />
                                <ImageInput
                                  // label="อัพโหลดรายการเดินบัญชีย้อนหลังไม่น้อยกว่า 6 เดือน (โหลดจากแอพธนาคาร)"
                                  placeholder={t("image3")}
                                  {...propagateSecondStatementFileChange()}
                                  fileInfo={secondStatementFileInfo}
                                  accept="application/pdf"
                                />
                              </div>
                              <div className="bUpload">
                                <label className="label">
                                  {t("uploadBank")}
                                </label>
                                <SelectInput
                                  isFormik={false}
                                  label={t("selectBank")}
                                  placeholder={t("selectBank")}
                                  options={BANK_NAME_OPTIONS}
                                  value={thirdStatementBank}
                                  onChange={async (e) => {
                                    const bankName = e.target.value;

                                    setThirdStatementBank(bankName);

                                    await syncFileNameWithBankName(
                                      bankName,
                                      thirdStatementFileInfo,
                                      onSetThirdStatementFileInfo
                                    );
                                  }}
                                  style={{ marginBottom: "12px" }}
                                />
                                <ImageInput
                                  // label="อัพโหลดรายการเดินบัญชีย้อนหลังไม่น้อยกว่า 6 เดือน (โหลดจากแอพธนาคาร)"
                                  placeholder={t("image3")}
                                  {...propagateThirdStatementFileChange()}
                                  fileInfo={thirdStatementFileInfo}
                                  accept="application/pdf"
                                />
                              </div>
                            </>
                          )}

                          {!isForeigner && !isMou && (
                            <ImageInput
                              label={t("imageForeign1")}
                              description={t("imageForeign1Desc")}
                              placeholder={t("imageForeign1Place")}
                              {...propagateNcbFileChange()}
                              fileInfo={ncbFileInfo}
                              accept="application/pdf"
                              required
                              errorMessage={ncbErrorMessage}
                            />
                          )}
                          {!isMou && (
                            <ImageInput
                              label={t("imageMou1")}
                              placeholder={t("imageMou1Place")}
                              {...propagateOtherDocumentFileChange()}
                              fileInfo={otherDocumentFileInfo}
                              required={false}
                            />
                          )}
                        </div>
                        <FooterButton
                          onSubmit={handleSubmit}
                          submitButtonTitle={t("confirm")}
                        />
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillFormStep;
